import { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { desktopMarginsCutoff } from "../../styleConstants";
import ContactsSection from "./ContactsSection";
import VoterSection from "./VoterSection/VoterSection";
import Footer from "./Footer/Footer";

const Wrapper = styled.div`
  padding-top: 16px;
  padding-bottom: ${(props) => props.$footerHeight + 20}px;
  font-size: 16px;

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    font-size: 16px;
    padding-top: 34px;
    padding-bottom: ${(props) => props.$footerHeight + 42}px;
  }
`;

const Divider = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

const Account = () => {
  const [footerHeight, setFooterHeight] = useState(null);
  const userInfo = useSelector((state) => state.userInfo.value);
  const userFull = useSelector((state) => state.user.value);

  // userFull being null, means there is no user signed in.
  // userFull being undefined means we don't know if there is a user. we are still fetching and it will either fetch user data or resolve to null.
  // we leave the page if null (no user), but stay here if undefined (still waiting to resolve.)
  if (userFull === null) {
    return <Navigate to="/signin" replace />;
  } else if (userFull === undefined) {
    return null;
  }

  const userContact = userInfo?.phone || userInfo?.email || "";
  const emails = userFull?.emails || [];
  const phones = userFull?.phones || [];
  const altContacts = [...emails, ...phones].filter((c) => c !== userContact);

  return (
    <Wrapper $footerHeight={footerHeight}>
      <ContactsSection primaryContact={userContact} altContacts={altContacts} />
      <Divider />
      <VoterSection voterConnection={userFull?.voterConnection} />
      <Footer setFooterHeight={setFooterHeight} />
    </Wrapper>
  );
};

export default Account;
